import { createTag } from '@frontend/api-client/utils';
import type { BaseApi } from '@frontend/api-client/utils/types';
import type {
  CreateInviteRequest,
  CreateInviteResponse,
  RetrieveInviteResponse,
  RetrieveReferralsResponse,
} from '@frontend/api-types';
import { convertArrayObjectKeysCase, convertObjectKeysCase } from '@frontend/duck-tape';
import { INVITES_ENDPOINTS } from './endpoints';

export const getInvitesApi = (baseApi: BaseApi) =>
  baseApi.injectEndpoints({
    endpoints: (builder) => ({
      createInvite: builder.mutation<CreateInviteResponse, CreateInviteRequest>({
        invalidatesTags: () => [createTag('Household')],
        query: ({ id: _id, ...rest }) => ({
          body: convertObjectKeysCase(rest, 'snakeCase'),
          method: 'POST',
          url: INVITES_ENDPOINTS.createInvite(),
        }),
      }),
      expireInvite: builder.mutation<void, string>({
        invalidatesTags: () => [createTag('Household')],
        query: (inviteId) => ({
          method: 'POST',
          url: INVITES_ENDPOINTS.expireInvite(inviteId),
        }),
      }),
      retrieveInvite: builder.query<RetrieveInviteResponse, string>({
        query: (inviteId) => INVITES_ENDPOINTS.retrieveInvite(inviteId),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as RetrieveInviteResponse,
      }),
      retrieveReferrals: builder.query<RetrieveReferralsResponse[], void>({
        query: () => INVITES_ENDPOINTS.retrieveReferrals(),
        transformResponse: (response: GenericRecord[]) =>
          convertArrayObjectKeysCase(response, 'camelCase') as RetrieveReferralsResponse[],
      }),
    }),
    overrideExisting: true,
  });
